import { Modal } from '@rd-web-markets/shared/dist/util';
import React, { useState, useRef } from 'react';
import { Form, Col, Row, Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const UploadDocumentsModal = _ref => {
  let {
    financialDetails,
    handleSubmit,
    showModal,
    setShowModal
  } = _ref;
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const hiddenFileInput = useRef(null);
  const {
    t
  } = useTranslation();
  const addFile = event => {
    setSelectedFile(event.target.files[0]);
  };
  const onSelectDetail = e => {
    setSelectedDetail(e.target.value);
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const submit = () => {
    if (!selectedDetail) {
      window.alert('Please choose an item first');
    } else if (!selectedFile) {
      window.alert('Please attach a file first');
    } else {
      setSelectedFile(null);
      setSelectedDetail(null);
      handleSubmit(selectedDetail, selectedFile);
      hiddenFileInput.current.value = '';
    }
  };
  const uploadDocumentBody = () => {
    return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form.Group, {
      className: "mb-2",
      as: Row
    }, /*#__PURE__*/React.createElement(Col, {
      md: 9
    }, /*#__PURE__*/React.createElement(Form.Label, {
      column: true,
      md: 4
    }, t('select_item')), /*#__PURE__*/React.createElement(Form.Control, {
      as: "select",
      name: "id",
      size: "md",
      type: "text",
      onChange: onSelectDetail,
      value: selectedDetail
    }, /*#__PURE__*/React.createElement("option", {
      key: null,
      value: null
    }), financialDetails.map(detail => /*#__PURE__*/React.createElement("option", {
      key: detail.id,
      value: detail.id
    }, detail.cost_type, " ", financialDetails.filter(fd => fd.cost_type === detail.cost_type).findIndex(fd => fd.id === detail.id) + 1)))), /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: handleClick,
      disabled: !selectedDetail
    }, t('select_file')), /*#__PURE__*/React.createElement("input", {
      style: {
        display: 'none'
      },
      type: "file",
      ref: hiddenFileInput,
      onChange: e => addFile(e)
    }), /*#__PURE__*/React.createElement("p", null, selectedFile && selectedFile.name)))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showModal && /*#__PURE__*/React.createElement(Modal, {
    show: showModal,
    size: "lg",
    title: "Upload Document",
    renderBody: () => uploadDocumentBody(),
    onHide: () => setShowModal(false),
    closeText: "Close",
    onSubmit: submit
  }));
};
export default UploadDocumentsModal;